/*
 * @Author: Teemo Ding
 * @Date: 2021-07-09 17:04:01
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 15:57:42
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Taxes/TaxEditPage/TaxApplies/index.tsx
 */
// import { Form } from 'antd';
// import { Radio } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import ProductSelectionWithHsCode from 'src/constrains/ProductsSelection/ProductSelectionWithHsCode';
import css from '../css.module.less';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

// enum ApplyTo {
//   All = 'All',
//   HsCode = 'HsCode',
//   Specific = 'Specific',
// }
// const AppliesList = [
//   {
//     value: ApplyTo.All,
//     label: 'All Products',
//   },
//   {
//     value: ApplyTo.HsCode,
//     label: 'HS Code + Class of Dangerouse Goods',
//   },
//   {
//     value: ApplyTo.Specific,
//     label: 'Specific Products',
//   },
// ];
const TaxApplies = ({ data, handleOnChange, disabled, disableEdit }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      title={getI18n('storeTaxes.taxListPage.taxAppliesto')}
      subtitle={getI18n('storeTaxes.taxEditPage.taxAppliestoSubTitle')}>
      {disabled ? null : (
        <ProductSelectionWithHsCode
          hsCodeError={''}
          specificError={''}
          data={data}
          onChange={handleOnChange}
          disableEdit={disableEdit}
        />
      )}
    </SectionWrapper>
  );
};

export default TaxApplies;
